import validator from 'validator';
import { BLOCKED } from './blocklist.js';
import { tlds } from '@hapi/tlds';
const isValidTld = (email) => {
    const tld = email.split('.').pop();
    return tlds.has(tld);
};
const HAS_QUOTE = new RegExp('"');
const isQuoted = (email) => {
    return HAS_QUOTE.test(email);
};
const validatorJs = (email) => validator.default.isEmail(email, {
    domain_specific_validation: true,
    host_blacklist: BLOCKED,
});
export const emailValidator = {
    validate: (original) => {
        const email = original?.toLowerCase()?.trim();
        if (!validatorJs(email)) {
            return { valid: false, error: 'invalid email' };
        }
        if (isQuoted(email)) {
            return { valid: false, error: 'quotes are not permitted' };
        }
        if (!isValidTld(email)) {
            return { valid: false, error: `email tld is not recognised` };
        }
        return { valid: true, email };
    },
};
